import React, { memo } from "react";
import { timeHHMM } from "../../../core";
import { useStyles } from "./QuestionBubbleStyle";
import Seen from "../../../assets/images/seen.svg";

const QuestionContent = memo(({ questionText, createdAt }) => {
  const styles = useStyles();
  return (
    <div className={styles.container}>
      {questionText && (
        <>
          <div
            className={`${styles.questionBubble} ${
              /^[a-zA-Z]/i.test(questionText)
                ? styles.ltrDirection
                : styles.rtlDirection
            }`}
          >
            {questionText}
          </div>
          <div className={styles.seenBox}>
            <div className={styles.time}>{timeHHMM(createdAt)}</div>
            <img alt="seen" src={Seen} />
          </div>
        </>
      )}
    </div>
  );
});

export { QuestionContent };
